import { ToastService } from "@shared/lib/services";
import { BackednResponse, IOrganisationFacets } from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { ORGANISATION_FACETS_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export function useGetOrganisationFacets() {
  const { data, isError, error, isFetching } = useQuery<
    BackednResponse<IOrganisationFacets>
  >({
    queryKey: [...ORGANISATION_FACETS_QUERY_KEY],
    queryFn: () => OrganisationService.getOrganisationFacets(),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data,
    isFacetsError: isError,
    isFacetsFetching: isFetching,
  };
}
